<div *ngIf="!!breadcrumbs?.length" fxLayout="row" fxLayoutAlign="start center">
    <div fxLayout="row" fxLayoutAlign="start center" *ngFor="let breadcrumb of breadcrumbs; let last = last">
        <ng-container *ngIf="!last">
            <span class="route" [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</span>
            <mat-icon color="primary">arrow_right</mat-icon>
        </ng-container>
        <ng-container *ngIf="last">
            <span>{{ breadcrumb.label }}</span>
        </ng-container>
    </div>
</div>
